import React from 'react';

// Hodinová sadzba podľa kategórie — pre porovnanie s cenníkom
const HOURLY_RATE_DEFAULT = 50;

// Formulár na pridávanie/editovanie záznamov pre Evidenciu Práce
const EvidenciaPraceForm = ({
  newEntry,
  setNewEntry,
  handleAddEntry,
  companies,
}) => {
  const timeCalc = newEntry.minutes > 0 && newEntry.unitPrice > 0
    ? (newEntry.minutes / 60) * newEntry.unitPrice
    : null;
  const hourlyCalc = newEntry.minutes > 0
    ? (newEntry.minutes / 60) * HOURLY_RATE_DEFAULT
    : null;

  return (
    <div className="entry-form">
      <h2>Nový záznam</h2>
      <div className="form-grid">
        <div className="form-group">
          <label>Firma *</label>
          <input
            type="text"
            list="companies-list"
            value={newEntry.companyName}
            onChange={(e) => setNewEntry({ ...newEntry, companyName: e.target.value })}
            placeholder="Názov firmy"
          />
          <datalist id="companies-list">
            {companies.map(company => (
              <option key={company} value={company} />
            ))}
          </datalist>
        </div>
        <div className="form-group">
          <label>Dátum *</label>
          <input
            type="date"
            value={newEntry.date}
            onChange={(e) => setNewEntry({ ...newEntry, date: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label>Obdobie od * <span style={{ color: '#dc2626', fontSize: 11 }}>(povinné)</span></label>
          <input
            type="month"
            value={newEntry.workPeriodFrom || ''}
            onChange={(e) => setNewEntry({ ...newEntry, workPeriodFrom: e.target.value })}
            style={{ borderColor: newEntry.workPeriodFrom ? undefined : '#fca5a5' }}
          />
        </div>
        <div className="form-group">
          <label>Obdobie do <span style={{ color: '#64748b', fontSize: 11 }}>(nepovinné — ak sa práca týka viacerých mesiacov)</span></label>
          <input
            type="month"
            value={newEntry.workPeriodTo || ''}
            onChange={(e) => setNewEntry({ ...newEntry, workPeriodTo: e.target.value })}
            min={newEntry.workPeriodFrom || undefined}
          />
        </div>
        <div className="form-group">
          <label>Popis práce *</label>
          <input
            type="text"
            value={newEntry.description}
            onChange={(e) => setNewEntry({ ...newEntry, description: e.target.value })}
            placeholder="Napr. Účtovanie dokladov za júl"
          />
        </div>
        <div className="form-group">
          <label>Trvanie (minúty)</label>
          <input
            type="number"
            step="1"
            min="0"
            value={newEntry.minutes}
            onChange={(e) => setNewEntry({ ...newEntry, minutes: parseInt(e.target.value) || 0 })}
            placeholder="napr. 45"
          />
        </div>
        <div className="form-group">
          <label>Hodinová sadzba (€/h)</label>
          <input
            type="number"
            step="0.01"
            value={newEntry.unitPrice}
            onChange={(e) => setNewEntry({ ...newEntry, unitPrice: parseFloat(e.target.value) || 0 })}
          />
        </div>

        {/* Porovnanie hodinovka */}
        {newEntry.minutes > 0 && (
          <div className="form-group full-width" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 7, padding: '10px 14px', marginTop: 2 }}>
            <div style={{ fontWeight: 600, fontSize: 12, color: '#475569', marginBottom: 6 }}>Porovnanie ceny:</div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
              {timeCalc !== null && (
                <span style={{
                  background: '#dcfce7', border: '1px solid #86efac',
                  borderRadius: 5, padding: '4px 10px', fontSize: 12, fontWeight: 700, color: '#16a34a'
                }}>
                  ⏱ Hodinovka ({newEntry.unitPrice}€/h): <strong>{timeCalc.toFixed(2)} €</strong>
                </span>
              )}
              {hourlyCalc !== null && newEntry.unitPrice !== HOURLY_RATE_DEFAULT && (
                <span style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 5, padding: '4px 10px', fontSize: 12, color: '#64748b' }}>
                  50€/h ref.: {hourlyCalc.toFixed(2)} €
                </span>
              )}
            </div>
          </div>
        )}

        <div className="form-group">
          <label>Skutočná cena v faktúre (€)</label>
          <input
            type="number"
            step="0.01"
            value={newEntry.actualInvoicePrice}
            onChange={(e) => setNewEntry({ ...newEntry, actualInvoicePrice: parseFloat(e.target.value) || 0 })}
            placeholder="Čo naozaj fakturujete"
          />
        </div>
        <div className="form-group full-width">
          <label>Poznámka * <span style={{ color: '#dc2626', fontSize: 11 }}>(povinné — uveďte konkrétny detail, napr. meno pracovníka)</span></label>
          <input
            type="text"
            value={newEntry.note}
            onChange={(e) => setNewEntry({ ...newEntry, note: e.target.value })}
            placeholder="Napr. Prihlásenie: Ján Novák, nar. 1990"
            style={{ borderColor: newEntry.note ? undefined : '#fca5a5' }}
          />
        </div>
      </div>
      <button onClick={handleAddEntry} className="btn-add">Pridať záznam</button>
    </div>
  );
}

export default EvidenciaPraceForm;
